
<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-close">
                        <button class="btn btn--white" @click="$emit('close')">
                            Close
                        </button>
                    </div>


                    <div class="modal-content ">

                        <div class="modal-header">
                            <h3>
                                <slot name="header">

                                </slot>
                            </h3>
                        </div>

                        <div class="modal-body ">
                            <slot name="body">

                            </slot>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </transition>
</template>




<script>

    export default {
        name: 'StandardModal'
    }
</script>

<style scoped>
    .modal-close {
        position: absolute;
        top: 0;
        right: 0;
    }

        .modal-close button{
            text-indent: -9999px;
            width: 78px;
            height: 78px;
            background-position: center center;
            background-image: url(/Assets/img/booking/button-cancel-cross.svg);
            background-size: 22px 22px;
            background-repeat: no-repeat;
            min-width: unset;
        }

        .modal-mask {
            position: fixed;
            z-index: 1000;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            display: table;
            transition: opacity 0.3s ease;
        }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 90%;
        /*height: auto;*/
        height: 80vh;
        max-width: 1400px;
        margin: 0px auto;
        background-color: #eae5e3;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        height: 90vh;
        overflow: auto;
        padding: 30px;
    }

    .modal-content {
        flex-grow: 1;
        text-align: left;
        height: 100%;
    }

    .modal-header{
        text-align: center;
    }

    .modal-logo {
        background-color: #eae5e3;
        border-radius: 50%;
        width: 80px;
        height: 80px;
        position: absolute;
        left: 50%;
        top: -40px;
        transform: translateX(-50%);
    }

        .modal-logo img {
            display: block;
            margin: 0 auto;
            height: 44px;
            top: 50%;
            transform: translateY(-50%);
            position: relative;
        }

    .modal-header h3 {
        margin-top: 0;
        font-size: 36px;
    }

    .modal-body {
        margin: 20px 0;
        padding-bottom: 20px;
    }

    .modal-default-button {
        float: right;
    }

    .modal-footer {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */
        .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

        .modal-enter .modal-container,
        .modal-leave-active .modal-container {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
        }




    /*
        SPA - TREATMENTS
    */

    .spa .treatments .modal-container {
        height: 90vh;
        overflow: auto;
    }

    .spa .treatments .modal-content {
        height: 100%;
    }

    @media (max-width: 767px) {
        .modal-container {
            padding: 80px 20px 40px 20px;
        }
    }
</style>